import {CardStackData, ICardStackData} from '../data/active_data/field_config/CardStackData';
import {ActiveData} from '../data/ActiveData';
import {CardData, ICardData, MetaType} from '../data/active_data/field_config/card_stack_data/CardData';
import {ActiveDataCommands} from './active_data_commands_controller/ActiveDataCommands';
import {IOperationItem} from './active_data_commands_controller/IOperationItem';
import {ArrayWrap} from '../data/active_data/base/static_config_data/ArrayWrap';
import {Stack} from '../pixi_scene/game_scene/game_table/table_objects/stacks/Stack';
import {DynamicData} from '../data/DynamicData';

export class ActiveDataCommandsController
{
    static diffHandler(data: IOperationItem[]): void {
        let stackData: CardStackData;
        data.forEach((operationItem: IOperationItem) => {
            switch (operationItem.operation) {
                case ActiveDataCommands.ADD_STACK:
                    ActiveDataCommandsController.addStack(operationItem.value.stack);
                    break;
                case ActiveDataCommands.DELETE_STACKS:
                    ActiveDataCommandsController.deleteStacks(operationItem.value.ids);
                    break;
                case ActiveDataCommands.DELETE_STACK_CARDS:
                    stackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == operationItem.value.id)!;
                    operationItem.value.cardIds.forEach((id: number) => {
                        if (stackData) {
                            let cardData: CardData = stackData.cards.classes.find(cardData => cardData.id == id)!;
                            stackData.cards.remove(cardData);
                        }
                    });
                    break;
                case ActiveDataCommands.ADD_STACK_CARDS:
                    stackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == operationItem.value.id)!;
                    operationItem.value.cards.forEach((cardData: ICardData) => {
                        stackData.cards.push(cardData);
                    });
                    break;
                case ActiveDataCommands.MOVE_STACK:
                    ActiveDataCommandsController.moveStack(operationItem.value.id, operationItem.value.x, operationItem.value.y);
                    break;
                case ActiveDataCommands.FLIP_STACK:
                    ActiveDataCommandsController.flipStackId(operationItem.value.id, operationItem.value.cards);
                    break;
                case ActiveDataCommands.FLIP_CARD:
                    ActiveDataCommandsController.flipCard(operationItem.value.id);
                    break;
                case ActiveDataCommands.CLEAR_FIELD:
                    DynamicData.fieldClear = true;
                    break;
                case ActiveDataCommands.ADD_CARDS:
                    ActiveDataCommandsController.addCardsToHand(operationItem.value.cards, operationItem.value.handIndex);
                    break;
                case ActiveDataCommands.DELETE_CARDS:
                    ActiveDataCommandsController.removeCardsFromHand(operationItem.value.ids);
                    break;
                case ActiveDataCommands.CHANGE_PLAYER_CARDS_COUNT:
                    ActiveData.root.getPlayerData(operationItem.value.playerId).cardsCount = operationItem.value.count;
                    break;
                case ActiveDataCommands.LOCK_STACK:
                    stackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == operationItem.value.id)!;
                    stackData.locked = true;
                    stackData.masterLocked = operationItem.value.masterLock;
                    break;
                case ActiveDataCommands.UNLOCK_STACK:
                    stackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == operationItem.value.id)!;
                    stackData.locked = false;
                    stackData.masterLocked = operationItem.value.masterLock;
                    break;
                case ActiveDataCommands.SHUFFLE_STACK:
                    ActiveDataCommandsController.shuffleStack(operationItem.value.id, operationItem.value.cards);
                    break;
                case ActiveDataCommands.ROTATE_STACK:
                    ActiveDataCommandsController.rotateStack(operationItem.value.id, operationItem.value.angle);
                    break;
                case ActiveDataCommands.DISABLE_STACKS:
                    ActiveDataCommandsController.actionDisableStacks(operationItem.value.ids, operationItem.value.playerId, operationItem.value.block);
                    break;
                case ActiveDataCommands.ENABLE_STACKS:
                    ActiveDataCommandsController.actionEnableStacks(operationItem.value.ids);
                    break;
                case ActiveDataCommands.CHANGE_META_TYPE:
                    ActiveDataCommandsController.actionChangeMetaType(operationItem.value.ids, operationItem.value.metaType);
                    break;
                case ActiveDataCommands.CHANGE_STACK_VISIBILITY:
                    ActiveDataCommandsController.actionChangeStackVisibility(
                        operationItem.value.id,
                        operationItem.value.invisibleFor,
                        operationItem.value.visibleFor,
                        operationItem.value.flippedFor,
                        operationItem.value.hiddenFor);
                    break;
                default:
                    console.log('Unknown operation: ' + JSON.stringify(operationItem));
            }
        });
        ActiveData.dispatchEventsPool();
    }

    /**
     * Добавляем новую колоду на стол
     * @param stack - статичные данные для колоды
     */
    static addStack(stack: ICardStackData): void {
        ActiveData.root.card_stacks.push(stack);
    }

    /**
     * Переворачиваем колоду
     * @param stackId - идентификатор колоды
     * @param cards -  статичные данные её карт
     */
    static flipStackId(stackId: number, cards?: ICardData[]): void {
        let stackData: CardStackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == stackId)!;
        ActiveDataCommandsController.flipStackData(stackData, cards);
    }

    /**
     * Переворачиваем колоду
     * @param stackData - данные колоды
     * @param cards -  статичные данные её карт
     */
    static flipStackData(stackData: CardStackData, cards?: ICardData[]): void {
        let processFlip: boolean = true;
        cards && cards.forEach((item: ICardData) => {
            let cardData: CardData = stackData.cards.classes.find(cardData => cardData.id == item.id)!;
            if (cardData.flipped == item.flipped) {
                processFlip = false;
            }
            cardData.flipped = item.flipped;
        });

        if (processFlip) {
            stackData.cards.reverse();
            stackData.flip();
        }
    }

    /**
     * Переворачиваем карту
     * @param stackId - идентификатор колоды
     * @param cards -  статичные данные её карт
     */
    static flipCard(cardId: number): void {
        let playerCardsData: ArrayWrap<CardData, ICardData> = ActiveData.root.getCurrentPlayerData().cards;
        let cardData: CardData = playerCardsData.classes.find(cardData => cardData.id == cardId)!;
        cardData.flipped = !cardData.flipped;
    }

    /**
     * Переворачиваем колоду
     * @param stackId - идентификатор колоды
     * @param cards -  статичные данные её карт
     */
    static addCardsToHand(cards: ICardData[], handIndex: number): void {
        for (let cardData of cards) {
            ActiveData.root.getCurrentPlayerData().cards.insert(handIndex++, cardData);
        }
    }

    /**
     * Переворачиваем колоду
     * @param stackId - идентификатор колоды
     * @param cards -  статичные данные её карт
     */
    static removeCardsFromHand(ids: number[]): void {
        let playerCardsData: ArrayWrap<CardData, ICardData> = ActiveData.root.getCurrentPlayerData().cards;
        for (let id of ids) {
            playerCardsData.remove(playerCardsData.classes.find(cardData => cardData.id == id)!);
        }
    }

    /**
     * Удаляем колоды
     * @param stackIds - идентификаторы колод
     */
    static deleteStacks(stacksIds: number[]): void {
        stacksIds.forEach((id: number) => {
            let cardStackData: CardStackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == id)!;
            ActiveData.root.card_stacks.remove(cardStackData);
        });
    }

    /**
     * Перемещаем колоду
     * @param stackId - идентификатор колоды
     * @param x - новая координата по горизонтали
     * @param y - новая координата по вертикали
     */
    static moveStack(stackId: number, x: number, y: number): void {
        let stackData: CardStackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == stackId)!;
        stackData.x = x;
        stackData.y = y;
    }

    /**
     * Тасуем колоду
     * @param stackId - идентификатор колоды
     * @param cards -  статичные данные её карт
     */
    static shuffleStack(stackId: number, cards: ICardData[]): void {
        let stackData: CardStackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == stackId)!;

        if (!stackData) {
            console.warn('Trying to shuffle not existing stack, skipping');
            return;
        }

        cards.forEach((item: ICardData) => {
            stackData.cards.shift();
        });
        cards.forEach((item: ICardData) => {
            stackData.cards.push(item);
        });

        ActiveData.hideEvents();
        ActiveData.dispatchEventsPool();
        ActiveData.showEvents();

        stackData.shuffle();
        ActiveData.dispatchEventsPool();
    }

    /**
     * action: disable stacks
     */
    static actionDisableStacks(ids: Array<number>, playerId: string, block: boolean): void {
        let stackData: CardStackData;
        ids.forEach(id => {
            stackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == id)!;
            stackData.usedByPlayer = playerId;
            stackData.blockedByPlayer = block ? playerId : '';
        });
    }

    /**
     * action: enable stacks
     */
    static actionEnableStacks(ids: number[]): void {
        let stackData: CardStackData;

        ids.forEach(id => {
            stackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == id)!;
            stackData.usedByPlayer = '';
            stackData.blockedByPlayer = '';
        });
    }

    /**
     * Удаляем временные колоды стола
     * @param stack
     */
    static removeTempStack(stack: Stack): void {
        ActiveData.root.card_stacks.remove(stack.activeData);
        ActiveData.dispatchEventsPool();
    }

    /**
     * Поворачиваем колоду
     * @param stackId - идентификатор колоды
     * @param angle - угол поворота в градусах
     */
    private static rotateStack(stackId: number, angle: number) {
        let stackData: CardStackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == stackId)!;
        stackData.angle = angle;
    }

    private static actionChangeMetaType(ids: number[], metaType: MetaType) {
        ActiveData.root.card_stacks.classes
            .forEach(cardStackData => cardStackData.cards.classes
                .filter(cardData => ids.includes(cardData.id))
                .forEach(cardData => cardData.metaType = metaType)
            );
    }

    private static actionChangeStackVisibility(stackId: number, invisibleFor: string[], visibleFor: string[], flippedFor: string[], hiddenFor: string[]): void {
        let stackData: CardStackData = ActiveData.root.card_stacks.classes.find(stackData => stackData.id == stackId)!;
        invisibleFor.forEach(userId => {
            stackData.invisibleFor.interfaces.includes(userId) || stackData.invisibleFor.push(userId);
        });
        for (let index: number = 0; index < stackData.invisibleFor.length; index++) {
            if (!invisibleFor.includes(stackData.invisibleFor.getAt(index).value)) {
                stackData.invisibleFor.splice(index, 1);
                index--;
            }
        }
    }
}
